export default __webpack_public_path__ + "static/media/screen2.e1774661.png";